import Vue from 'vue'
import VueI18n from 'vue-i18n'
import local_es from './locals/es'
import local_ca from './locals/ca'
import local_en from './locals/en'
import local_de from './locals/de'

Vue.use(VueI18n)

export default new VueI18n({
    locale: '',
    messages: {
        es: local_es,
        ca: local_ca,
        en: local_en,
        de: local_de
    }
})

//export const I18n = new VueI18n();
